/**
 * SVG中截断文本的组件
 * 这个组件使用SVG `<text>`进行包装，现在text中只能为字符串，如果非字符串，将不进行处理
 * @type {string}
 */
import React from 'react';

// const ELLIPSIS = '...';

export default class SvgTextEllipsis extends React.Component {
  constructor(props) {
    super(props);
    const { children } = this.props
    this.state = { content: children };
  }

  componentDidMount() {
    const { children, width } = this.props;
    if (typeof children === 'string') {
      setTimeout(() => this.textEllipsis(width), 50);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { children, width } = this.props;
    if (
      (nextProps.children !== children && typeof nextProps.children === 'string') ||
      nextProps.width !== width
    ) {
      this.textEllipsis(nextProps.width);
      this.setState({ content: nextProps.children });
    }
  }

  text;

  textEllipsis() {
    const { content } = this.state;

    if(content.indexOf(',') >= 0) {
      if(content.split(',').length>1){
        return content.split(',')[0]+'+'+content.split(',').length
      }
    }
    return content;

    // if (this.text && typeof this.text.getComputedTextLength !== 'undefined') {
    //   if (this.text.getComputedTextLength() > width) {
    //     // 计算如果文字长度超出素材宽度，剪切超出部分，在后面拼接“...”
    //     let textContent = content;
    //     if (content.indexOf(ELLIPSIS) >= 0) {
    //       textContent = content.substring(content.indexOf(ELLIPSIS) + 3, content.length);
    //     }
    //     textContent = textContent.slice(0, -1) + ELLIPSIS;
    //     return textContent;
    //   }
    // }
    // return content;
  }

  render() {
    const { width } = this.props;
    return (
      <text
        cursor="default"
        {...this.props}
        ref={e => {
          this.text = e;
        }}
      >
        {this.textEllipsis(width)}
      </text>
    );
  }
}
